module.exports = __webpack_public_path__ + "img/cargo-wagon-door-horizontal-side.41d5dbd9.png";